// Brand palette derived from the Bizsprite logo:
//   blue  #29ABE2 (primary brand)
//   amber #FFB700 (accent)
//   cream #FFF5AB (light accent)
// These scales are the single source of truth; components reference tokens.

const blue = {
  50: '#E8F7FD',
  100: '#C7ECFA',
  200: '#9CDDF7',
  300: '#67CAF2',
  400: '#3DB8EB',
  500: '#29ABE2', // logo blue
  600: '#178FC5', // hover / deeper
  700: '#1272A0',
  800: '#145E83',
  900: '#154F6D',
};

const amber = {
  50: '#FFF9E6',
  100: '#FFEFC0',
  200: '#FFE48F',
  300: '#FFD14D',
  400: '#FFC224',
  500: '#FFB700', // logo amber
  600: '#E29500', // hover
  700: '#B97400',
  800: '#945A08',
  900: '#7A490B',
};

const colors = {
  // Neutral scale
  gray: {
    900: '#1A202C', // Primary text
    850: '#2D3748', // Darker text
    800: '#4A5568', // Secondary text
    700: '#667085', // Muted text
    600: '#98A2B3', // Disabled / faint text
    500: '#9CA3AF', // Strong borders
    400: '#D1D5DB', // Medium borders
    300: '#E5E7EB', // Light borders
    200: '#F1F6FA', // Subtle blue-tinted background
    100: '#F7FAFC', // Card background
    50: '#FFFFFF',  // Pure white
  },

  // Brand blue scale (drives blue colorScheme)
  blue,

  // Amber accent scale. `orange` is aliased to the same scale so existing
  // colorScheme="orange" usages stay on-brand.
  amber,
  orange: amber,

  // Green colors for success states
  green: {
    50: '#F0FDF4',
    100: '#DCFCE7',
    200: '#BBF7D0',
    300: '#86EFAC',
    400: '#4ADE80',
    500: '#22C55E',
    600: '#16A34A',
    700: '#15803D',
    800: '#166534',
    900: '#14532D',
  },

  // Red colors for error states
  red: {
    50: '#FEF2F2',
    100: '#FEE2E2',
    200: '#FECACA',
    300: '#FCA5A5',
    400: '#F87171',
    500: '#EF4444',
    600: '#DC2626',
    700: '#B91C1C',
    800: '#991B1B',
    900: '#7F1D1D',
  },

  // Text Colors
  text: {
    primary: '#1A202C',
    secondary: '#4A5568',
    muted: '#667085',
    light: '#98A2B3',
    inverted: '#FFFFFF',
  },

  // Brand tokens
  brand: {
    blue,
    amber,
    orange: {
      500: '#FFB700',
      600: '#E29500',
    },
    navy: '#0B3D5C', // deep brand navy for dark surfaces
  },

  // Chat-specific colors
  chat: {
    userBubble: '#29ABE2',
    aiBubble: '#F7FAFC',
    userText: '#FFFFFF',
    aiText: '#1A202C',
    timestamp: '#98A2B3',
    divider: '#E5E7EB',
    inputBorder: '#C7D6E0',
    inputFocus: '#29ABE2',
    hover: 'rgba(41, 171, 226, 0.06)',
    active: 'rgba(41, 171, 226, 0.12)',
  },

  // Semantic Colors
  success: '#22C55E',
  warning: '#FFB700',
  error: '#F04438',

  // Chart & Series Colors
  series: {
    yellow: '#FFD14D',
    purple: '#722ED1',
    cyan: '#13C2C2',
  },
};

export default colors;
